module.exports = __webpack_public_path__ + "static/media/wizard_1.4622c34f.png";